<template>
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <b-row class="my-4 min-width-full align-items-center">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="공지사항 제목을 입력하세요."
            v-model="search.title"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="2">
        <b-form-checkbox
          v-model="search.checkDeleted"
          v-on:click="handleChangeCheckbox"
          class="mt-sm"
        >
          삭제 포함
        </b-form-checkbox>
      </b-col>
      <b-col md="6" class="text-right">
        <Button :type="ButtonTypes.purple" :on-click="addNotice" label="추가"/>
      </b-col>
    </b-row>
    <b-table :fields="fields" :items="files" class="text-left">
      <template #cell(status)="data">
        <Badge
          :type="data.item.status === FilePublishTypes.UNPUBLISHED ? BadgeTypes.red : BadgeTypes.green"
          :label="data.item.status"
        />
      </template>
      <template #cell(url)="data">
        <p class="cursor" @click="copy(data.item.linkKey)">{{getURL(data.item.linkKey)}}</p>
      </template>
      <template #cell(button)="data">
        <div class="inline-flex gap-2 justify-end items-center text-right w-full">
          <span v-if="data.item.deletedAt !== null">{{getDate(data.item.deletedAt)}} 삭제</span>
          <Button
            v-if="!data.item.deletedAt"
            :type="ButtonTypes.yellow" label="상세" :onClick="() => setDetail(data.item.id)" />
          <Button
            v-if="!data.item.deletedAt"
            :type="ButtonTypes.red" label="삭제" :onClick="() => deleteNotice(data.item.id)" />
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import {copyText} from "vue3-clipboard";
import {BadgeTypes, ButtonTypes, PublishTypes} from "@/util/enums";
import Badge from "@/components/Badge.vue";
import Button from "@/components/Button.vue";
import customDate from "@/util/custom-date";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
    FilePublishTypes() {
      return PublishTypes
    }
  },
  components: {Button, Badge},
  data() {
    return {
      searchLessons: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      openModals: {
        new: false,
        detail: false
      },
      selectedLesson: {},
      fields: [
        {
          label: '제목',
          key: 'title',
        },
        {
          label: '노출상태',
          key: 'status',
        },
        {
          label: 'URL',
          key: 'url',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      files: [],
      search: {
        title: "",
        checkDeleted: false
      },
      selectedFile: null,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    if (query.checkDeleted === 'true') {
      this.search.checkDeleted = true
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    getURL(url) {
      return `${process.env.VUE_APP_WEB_URL}/notice/${url}`
    },
    copy(url){
      const fullURL = this.getURL(url)
      copyText(fullURL, fullURL, (err, event) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    handleChangeCheckbox() {
      this.search.checkDeleted = !this.search.checkDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.replace({ query })
    },
    setDetail(id) {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.push({
        path: `/notice/${id}`,
        query
      })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    addNotice() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      if (this.search.checkDeleted) {
        query.checkDeleted = 'true'
      }
      
      this.$router.push({
        path: '/notice/new',
        query
      })
    },
    deleteNotice(id){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '공지사항 삭제',
        html: '삭제 시 모든 데이터가 사라집니다.<br/>정말 삭제하시겠습니까??',
        confirm: () => {
          api.notice.deleteNotice(id, () => {
            this.getPagingList(this.currentPage)
          }, (err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
        widthDelete: this.search.checkDeleted
      }
      
      api.notice.searchNotices(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.files = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        // API 응답 후 currentPage를 요청한 페이지로 설정하여 b-pagination이 올바르게 표시되도록 함
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>
